// extracted by mini-css-extract-plugin
export var authorBio = "AuthorCard-module--author-bio--1672e";
export var authorCard = "AuthorCard-module--author-card--2ded5";
export var authorImage = "AuthorCard-module--author-image--6e332";
export var authorImg = "AuthorCard-module--author-img--5c742";
export var expertBadgeIcon = "AuthorCard-module--expert-badge-icon--bb7fe";
export var name = "AuthorCard-module--name--16467";